import DepsService from 'services/dependencies';
import appHelpers from 'app/app-helpers';
import tabs from 'dashboard/components/dashboard-widget/net-sales/tabs';

const CONTEXT = 'net-sales';
const { WTD, MTD, QTD, YTD } = tabs;

export const fetchNetSalesSummary = async (config) => {
  const { retailerId } = config;

  const url = DepsService.rest.widgets.netSales.url;
  const queryParams = {};
  const urlParams = { retailerId };

  const response = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return netSalesSummaryDataTransformation(response);
};

export const fetchNetSalesDetails = async (config) => {
  const { retailerId } = config;

  const url = DepsService.rest.widgets.netSalesDetails.url;
  const queryParams = {};
  const urlParams = { retailerId };

  const response = await DepsService.restSrv.get(CONTEXT, url, queryParams, urlParams);

  return netSalesDetailsDataTransformation(response);
};

export const downloadNetSalesHistoryReport = (config) => {
  const { periodType, retailerId, extension } = config;

  const url = DepsService.rest.widgets.netSalesDetails.url;
  const queryParams = { periodType };
  const urlParams = { retailerId };
  const headers = appHelpers.setHeader(extension);
  return DepsService.restSrv.downloadBlob(CONTEXT, url, queryParams, urlParams, headers);
};

export const netSalesSummaryDataTransformation = (data) => {
  let netSalesSummary = {};

  data.forEach((item) => {
    netSalesSummary = {
      ...netSalesSummary,
      [item.periodType]: {
        title: getSummaryDataDescription(item.periodType),
        ...item,
      },
    };
  });

  return netSalesSummary;
};

export const netSalesDetailsDataTransformation = (data) => {
  const drawProductType = 1;
  const instantProductType = 2;
  let instantGames = {};
  let drawGames = {};

  data.forEach(({ periodType, productType, ...game }) => {
    const isInstantGame = productType === instantProductType || game.gameName === 'eInstant';
    const isDrawGame = productType === drawProductType && game.gameName !== 'eInstant';

    if (isInstantGame) {
      const instantGamesArr = instantGames[periodType] || [];
      instantGames = {
        ...instantGames,
        [periodType]: [...instantGamesArr, ...[game]],
      };
    }

    if (isDrawGame) {
      const drawGamesArr = drawGames[periodType] || [];
      drawGames = {
        ...drawGames,
        [periodType]: [...drawGamesArr, ...[game]],
      };
    }
  });

  return {
    instantGames,
    drawGames,
  };
};

const getSummaryDataDescription = (periodType) => {
  switch (periodType) {
    case WTD:
      return DepsService.gettextCatalog.getString('Week to Date Net Sales');
    case MTD:
      return DepsService.gettextCatalog.getString('Month to Date Net Sales');
    case QTD:
      return DepsService.gettextCatalog.getString('Quarter to Date Net Sales');
    case YTD:
      return DepsService.gettextCatalog.getString('Year to Date Net Sales');
    default:
      return '';
  }
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/resources/net-sales.api.js